import { DashedLine } from "../shared/components/DashedLine"
import { Navbar } from "../shared/components/Navbar"
import { useLanguage } from "../shared/context/LanguageContext"

export function FQA() {
    const { translation } = useLanguage()

    return (
        <main>
            <div className="sticky  top-5 sm:top-0 md:relative z-50 mx-5 md:mx-7 lg:mx-10 xl:mx-[3.125rem] bg-secondary rounded-3xl">
                <Navbar />
            </div>
            <div className="flex flex-col gap-5 px-5 md:gap-9 md:py-9 md:px-9 lg:flex-row lg:gap-20 lg:py-0 lg:pt-[4.375rem] lg:px-[5.625rem]">
                <div className="max-w-[27%] w-full text-[1.75rem] md:text-3xl lg:text-[2.5rem] font-bold px-5 pt-9 lg:px-0 lg:pt-0 text-primary !leading-[130%]">{translation.faqTitle}</div>
                <div className="flex flex-col gap-5 md:gap-6 lg:gap-[1.875rem] px-5 lg:px-0 pb-[1.875rem] ld:pb-0">
                    {translation.questions.map((item, index) => (
                        <div key={index} className="flex flex-col gap-5 md:gap-6 lg:gap-[1.875rem]">
                            <div className="flex flex-col gap-2.5">
                                <div className="text-base font-bold md:text-lg lg:text-[1.375rem] text-primary whitespace-pre-line">
                                    {item.question}
                                </div>
                                <ul className="flex flex-col gap-2">
                                    {item.answers.map((answer, i) => (
                                        <li key={i} className="text-base font-normal md:text-lg lg:text-[1.375rem] text-black ms-6 md:ms-7 lg:ms-8 list-disc whitespace-pre-line">
                                            {typeof answer === 'object' ? <><span className="font-medium">{answer.bold}</span> {answer.description}</> : answer}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                            {index !== translation.questions.length - 1 && <DashedLine key={index} />}
                        </div>
                    ))}
                </div>
            </div>
        </main>
    )
}